import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import { SmartAutoSetting } from "../../models/KeySelectionOptions.model";
import OptionMenuOneLineToggle from "../theme_reuse/OptionMenuOneLineToggle";

interface Props {}
interface State {}

const shortNames = [SmartAutoSetting.Manual, SmartAutoSetting.AlwaysAuto, SmartAutoSetting.ContextualAuto];


function printShortName(x: SmartAutoSetting): string {
  switch (x) {
    case SmartAutoSetting.Manual:
      return "Do not automate";
    case SmartAutoSetting.ContextualAuto:
      return "Unless melodic minor is likely";
    case SmartAutoSetting.AlwaysAuto:
      return "Auto-silence mismatching 6th";
  }
}

export default class AutoIgnore6Toggle extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  changeSetting = (wrong6thIgnore: SmartAutoSetting) => {
    const oldOptions = this.context.keySelectionOptions;
    this.context.dispatch({
      type: "EditKeySelectionOptions",
      payload: { ...oldOptions, autoPin: { ...oldOptions.autoPin, wrong6thIgnore } },
    });
  };

  render(): ReactNode {
    const selected = this.context.keySelectionOptions.autoPin.wrong6thIgnore;
    return (
      <OptionMenuOneLineToggle
        selected={selected}
        printShortName={printShortName}
        onChange={this.changeSetting}
        optionShortNames={shortNames}
      />
    );
  }
}

AutoIgnore6Toggle.contextType = AppContextType;
